import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-noindex-page',
  standalone: true,
  template: ``
})
export class NoindexPageComponent implements OnInit {
  constructor(private meta: Meta) {}

  ngOnInit() {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
  }
}
